<template>
  <div>
    <AccountingRewardClientDetailsView v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountingRewardClientDetailsView>
    <AdminRewardClientDetailsView v-if="$getConstRole('ROLE_ADMIN') == role"></AdminRewardClientDetailsView>
    <AgentRewardClientDetailsView v-if="$getConstRole('ROLE_AGENT') == role"></AgentRewardClientDetailsView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AccountingRewardClientDetailsView from '@/views/accountant/rewards/View.vue'
import AdminRewardClientDetailsView from '@/views/admin/rewards/View.vue'
import AgentRewardClientDetailsView from '@/views/agent/rewards/View.vue'

export default {
  name: 'RewardClientDetails',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AccountingRewardClientDetailsView,
    AdminRewardClientDetailsView,
    AgentRewardClientDetailsView
  },
};
</script>
